import * as Yup from 'yup'

export const ProfessionValidationSchema = Yup.object().shape({
  desiredJob: Yup.array()
    .of(
      Yup.object({
        job: Yup.string(),
      }),
    )
    .min(1, 'Se requiere una Postulación para cargo'),
})
